import classNames from "classnames";

import Accordion from "@stadium/ui/src/components/accordion/accordion";
import Multimedia from "@sharedComponents/multimedia";

import useWithAnalytics from "@stadium/services/analytics/hooks/use-with-analytics";

import { ANALYTICS_TARGET_DIETARY_INFO } from "@constants/analytics/shop";

import styles from "./main.module.scss";

const DietaryRestriconsAccordion = ({ restrictions, productId }) => {
  const withAnalytics = useWithAnalytics();

  if (restrictions.length === 0) return null;
  return (
    <Accordion
      id="dietary-restrictions"
      tabIndex={0}
      customClass={classNames(styles.panelGroup, styles.sharedDescriptionWithFlag)}
      onClick={() => {
        withAnalytics(undefined, {
          target: ANALYTICS_TARGET_DIETARY_INFO,
          track: true,
          eventProperties: {
            product_id: productId,
          },
        })();
      }}
      titleContent={
        <div className={styles.acord}>
          <div className={styles.primaryColor}>Dietary Restrictions</div>
          <div className={`${styles.iconChevronUp} collapseicon`}></div>
        </div>
      }
    >
      {restrictions.map(({ id, icon, name }) => (
        <div key={`restriction-${id}`} className={`${styles.pill} ${styles.dietaryPill}`}>
          {icon && (
            <Multimedia
              type="image"
              isNextImage={false}
              src={icon}
              className="img-fluid"
              height={16}
              width={16}
            />
          )}
          <span className={styles.pillName}>{name}</span>
        </div>
      ))}
    </Accordion>
  );
};

export default DietaryRestriconsAccordion;
